import {
  BULK_SEND_FINAL_BE_STATUSES,
  BULK_SEND_IN_PROGRESS_STATUS,
  BULK_SEND_UNTITLED_LABEL,
} from '../../constants/bulkSendManager';
import { IUserTaskDoc, TUserTaskFinalStatus } from '../../types/userTask';

export interface IBulkSendStatusSnapshot {
  uid: string;
  title: string;
  status: string | undefined;
}

export interface IBulkSendTransition {
  uid: string;
  title: string;
  status: TUserTaskFinalStatus;
}

export type TBulkSendStatusByUid = Map<string, string | undefined>;

export const isBulkSendFinalStatus = (status: string | undefined): status is TUserTaskFinalStatus =>
  typeof status === 'string' && (BULK_SEND_FINAL_BE_STATUSES as string[]).includes(status);

export const toStatusSnapshot = (uid: string, doc: IUserTaskDoc): IBulkSendStatusSnapshot => ({
  uid,
  title: doc.title?.trim() || BULK_SEND_UNTITLED_LABEL,
  status: doc.status,
});

export const toStatusByUid = (snapshots: IBulkSendStatusSnapshot[]): TBulkSendStatusByUid =>
  new Map(snapshots.map((item) => [item.uid, item.status]));

export const detectBulkSendTransitions = (
  previous: TBulkSendStatusByUid,
  snapshots: IBulkSendStatusSnapshot[],
): IBulkSendTransition[] =>
  snapshots.reduce<IBulkSendTransition[]>((acc, item) => {
    if (previous.get(item.uid) !== BULK_SEND_IN_PROGRESS_STATUS || !isBulkSendFinalStatus(item.status)) {
      return acc;
    }

    return [...acc, { uid: item.uid, title: item.title, status: item.status }];
  }, []);
